import termsPdf from '../../documents/20210319-near-tcs.pdf';

const Terms = () => {
    window.location.href = termsPdf;
};

export default Terms;
